import { useState } from "react";
import CrudTable from "../components/CrudTable";
import { FileCCE } from "../components/ui";
import PDFButton from "../components/PDFButton";
import { FolderOpen, X } from "lucide-react";

export default function Providers() {
  const [selected, setSelected] = useState(null);
  const [showGlobalEvidence, setShowGlobalEvidence] = useState(false);
  return (
    <div data-testid="providers-module">
      <div className="flex items-center justify-between mb-3">
        <h1 className="card-h1" style={{ margin: 0 }}>Proveedores Ambientales</h1>
        <div className="flex gap-2">
          <button
            className="btn"
            onClick={() => setShowGlobalEvidence((v) => !v)}
            data-testid="providers-toggle-global-evidence"
          >
            <FolderOpen size={14} /> {showGlobalEvidence ? "Ocultar evidencia general" : "Evidencia general del módulo"}
          </button>
          <PDFButton endpoint="/pdf/module/providers" filename="reporte_proveedores.pdf" label="Reporte PDF" />
        </div>
      </div>

      {showGlobalEvidence && (
        <div className="card mb-3" data-testid="providers-global-evidence" style={{ background: "rgba(74,144,226,0.05)", border: "1px solid rgba(74,144,226,0.3)" }}>
          <div className="card-title">Evidencia general del módulo Proveedores Ambientales</div>
          <p className="text-xs text-dim mb-3">
            Sube aquí documentos transversales (contratos marco, RUPA, normativa interna, fotos generales de instalaciones).
            Para documentos específicos de un proveedor, haz click en su fila y carga la evidencia debajo. Soporta archivos
            individuales, múltiples archivos y <b>carpetas completas con subcarpetas</b>.
          </p>
          <FileCCE module="providers" parentId="" />
        </div>
      )}

      <CrudTable
        collection="providers"
        testIdPrefix="providers"
        onRowClick={(r) => setSelected(r)}
        fields={[
          { key: "name", label: "Nombre", required: true, full: true },
          { key: "rfc", label: "RFC" },
          { key: "address", label: "Domicilio", full: true },
          { key: "phone", label: "Teléfono" },
          { key: "email", label: "Correo" },
          { key: "main_contact", label: "Contacto principal" },
          { key: "emergency_contact", label: "Contacto 24h" },
          { key: "service_types", label: "Tipos de servicio" },
          { key: "score", label: "Score 0–100", type: "number" },
          { key: "status", label: "Status", type: "select", options: ["Aprobado", "En revisión", "Suspendido"] },
        ]}
      />
      {selected && (
        <div className="card mt-4" data-testid="provider-evidence-panel">
          <div className="flex justify-between items-start mb-3">
            <h3 className="card-h1" style={{ margin: 0, fontSize: 18 }}>{selected.name}</h3>
            <button className="btn btn-sm" onClick={() => setSelected(null)} data-testid="provider-evidence-close"><X size={12} /> Cerrar</button>
          </div>
          <div className="grid grid-cols-3 gap-3 mb-3">
            <div className="kpi-card"><div className="label">RFC</div><div className="value text-lg">{selected.rfc || "-"}</div></div>
            <div className="kpi-card"><div className="label">Score</div><div className="value">{selected.score || 0}/100</div></div>
            <div className="kpi-card"><div className="label">Status</div><div className="value text-lg">{selected.status || "-"}</div></div>
          </div>
          <h4 className="text-sm font-semibold mb-2">Evidencia documental — {selected.name}</h4>
          <p className="text-xs text-dim mb-2">
            Carga PDFs, fotos o carpetas completas (autorizaciones SEMARNAT, RUPA, certificados ISO, fotos de plantas, etc.).
          </p>
          <FileCCE module="providers" parentId={selected.id} />
        </div>
      )}
    </div>
  );
}
